import "./App.css";
import { jsPDF } from "jspdf";
import { defaultResume, objectTemplate } from "./modules/SampleObject";
import Footer from "./components/Footer";
import Form from "./components/form/Form";
import Navbar from "./components/Navbar";
import Preview from "./components/preview/Preview";
import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

function App() {
  const [resume, SetResume] = useState(
    JSON.parse(localStorage.getItem("savedResume")) || defaultResume
  );

  useEffect(() => {
    localStorage.setItem("savedResume", JSON.stringify(resume));
  }, [resume]);

  function removeData({ category, mainId, subId, subSubId } = {}) {
    const newResume = { ...resume };
    switch (category) {
      case "contact":
        newResume.contact.splice(mainId, 1);
        break;
      case "formInfo":
      case "formList":
        newResume.leftContents.splice(mainId, 1);
        break;
      case "formExperience":
      case "formReference":
        newResume.rightContents.splice(mainId, 1);
        break;
      case "itemInfo":
      case "itemList":
        newResume.leftContents[mainId].items.splice(subId, 1);
        break;
      case "itemListExperience":
        newResume.rightContents[mainId].items[subId].jobDetails.splice(
          subSubId,
          1
        );
        break;
      case "itemExperience":
      case "itemReference":
        newResume.rightContents[mainId].items.splice(subId, 1);
        break;
      default:
        break;
    }
    SetResume(newResume);
  }

  function updateData({
    category,
    subCategory,
    mainId,
    subId,
    subSubId,
    property,
    newValue,
  } = {}) {
    const newResume = { ...resume };
    switch (category) {
      case "bio":
        newResume.bio[property] = newValue;
        break;
      case "contact":
        newResume.contact[mainId][property] = newValue;
        break;
      case "profile":
        newResume.profile.profileSummary = newValue;
        break;
      case "leftColumnTitle":
        newResume.leftContents[mainId].name = newValue;
        break;
      case "info":
        newResume.leftContents[mainId].items[subId][property] = newValue;
        console.log(mainId + "subid:" + subId + property);
        break;
      case "list":
        if (subCategory === "none") {
          newResume.leftContents[mainId].items[subId][property] = newValue;
        } else if (subCategory === "level") {
          newResume.leftContents[mainId].items[subId][property] = newValue;
        } else if (subCategory === "score") {
          newResume.leftContents[mainId].items[subId][property] = newValue;
        }
        break;
      case "experienceInfo":
        newResume.rightContents[mainId].items[subId][property] = newValue;
        break;
      case "experienceList":
        newResume.rightContents[mainId].items[subId].jobDetails[subSubId].item =
          newValue;

        break;
      case "reference":
        newResume.rightContents[mainId].items[subId][property] = newValue;
        break;
      default:
    }
    SetResume(newResume);
  }

  function updateContactIcon(contactId, newIconId, newIconClass) {
    const newResume = { ...resume };
    newResume.contact[contactId].iconId = newIconId;
    newResume.contact[contactId].iconName = newIconClass;
    SetResume(newResume);
  }

  function addData({ category, mainId, subId } = {}) {
    const newResume = { ...resume };
    switch (category) {
      case "contact":
        const newContact = { ...objectTemplate.contactTemplate, id: uuidv4() };
        newResume.contact = [...newResume.contact, newContact];
        break;
      case "info":
        const newInfo = {
          ...objectTemplate.infoTemplate.items[0],
          id: uuidv4(),
        };
        newResume.leftContents[mainId].items = [
          ...newResume.leftContents[mainId].items,
          newInfo,
        ];
        break;
      case "listlevel":
        const newListLevel = {
          ...objectTemplate.listProficiencyTemplate.items[0],
          id: uuidv4(),
        };
        newResume.leftContents[mainId].items = [
          ...newResume.leftContents[mainId].items,
          newListLevel,
        ];
        break;
      case "listnone":
        const newListNone = {
          ...objectTemplate.listBasicTemplate.items[0],
          id: uuidv4(),
        };
        newResume.leftContents[mainId].items = [
          ...newResume.leftContents[mainId].items,
          newListNone,
        ];
        break;
      case "listscore":
        const newListScore = {
          ...objectTemplate.listScoreTemplate.items[0],
          id: uuidv4(),
        };
        newResume.leftContents[mainId].items = [
          ...newResume.leftContents[mainId].items,
          newListScore,
        ];
        break;
      case "experience":
        const newExperience = {
          ...objectTemplate.experienceTemplate.items[0],
          id: uuidv4(),
        };
        newExperience.jobDetails = [];
        newResume.rightContents[mainId].items = [
          ...newResume.rightContents[mainId].items,
          newExperience,
        ];
        break;
      case "experienceList":
        const newExperienceList = {
          ...objectTemplate.experienceListTemplate,
          id: uuidv4(),
        };
        newResume.rightContents[mainId].items[subId].jobDetails.push(
          newExperienceList
        );
        break;
      case "reference":
        const newReference = {
          ...objectTemplate.referenceTemplate.items[0],
          id: uuidv4(),
        };
        newResume.rightContents[mainId].items = [
          ...newResume.rightContents[mainId].items,
          newReference,
        ];
        break;
      case "infoSection":
        const newInfoSection = {
          ...objectTemplate.infoTemplate,
          id: uuidv4(),
        };
        newInfoSection.items[0].id = "";
        newInfoSection.items = [];
        console.log(objectTemplate.infoTemplate.items[0]);
        newResume.leftContents = [...newResume.leftContents, newInfoSection];
        break;
      case "listBasicSection":
        const newListBasicSection = {
          ...objectTemplate.listBasicTemplate,
          id: uuidv4(),
        };
        newListBasicSection.items = [];
        newResume.leftContents.push(newListBasicSection);
        break;
      case "listProficiencySection":
        const newListProficiencySection = {
          ...objectTemplate.listProficiencyTemplate,
          id: uuidv4(),
        };
        newListProficiencySection.items = [];
        newResume.leftContents.push(newListProficiencySection);
        break;
      case "listScoreSection":
        const newListScoreSection = {
          ...objectTemplate.listScoreTemplate,
          id: uuidv4(),
        };
        newListScoreSection.items = [];
        newResume.leftContents.push(newListScoreSection);
        break;
      case "experienceSection":
        const newExperienceSection = {
          ...objectTemplate.experienceTemplate,
          id: uuidv4(),
        };
        newExperienceSection.items = [];
        newResume.rightContents.push(newExperienceSection);
        break;
      case "referenceSection":
        const newReferenceSection = {
          ...objectTemplate.referenceTemplate,
          id: uuidv4(),
        };
        newReferenceSection.items = [];
        newResume.rightContents.push(newReferenceSection);
        break;
      default:
        break;
    }
    SetResume(newResume);
  }

  function saveAsPDF(callback) {
    //multiplier used because jsPDF output doesn't match declared paper size
    const multiplier = 0.945;
    const report = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: [841.89 * multiplier, 1190.55 * multiplier],
    });
    toggleBorder();
    report.html(document.querySelector(".preview-container")).then(() => {
      report.save("resume.pdf");
    });
    const myTimeout = setTimeout(toggleBorder, 2000);
  }

  function toggleBorder() {
    document
      .querySelector(".preview-container")
      .classList.toggle("show-border");
    document.querySelector(".resume-content").classList.toggle("show-border");
  }

  return (
    <>
      <Navbar saveAsPDF={saveAsPDF} />
      <div className="main-container text-slate-950">
        <Form
          resume={resume}
          updateData={updateData}
          updateContactIcon={updateContactIcon}
          addData={addData}
          removeData={removeData}
        />
        <Preview resume={resume} />
      </div>
      <Footer />
    </>
  );
}

export default App;
